import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AnalyticsService } from './service/analytics.service';
import { SeoService } from './service/seo.service';
import { Title, Meta } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { MetaService } from './service/meta.service';
import { SchemaService } from './service/schema.service';

declare var AOS: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private routerEventsSub?: Subscription;
  private aosInitialized = false;

  private readonly breadcrumbRouteMap: { [path: string]: Array<{ name: string; path: string }> } = {
    '/leadership': [{ name: 'Leadership', path: '/leadership' }],
    '/contact-us': [{ name: 'Contact Us', path: '/contact-us' }],
    '/about-us': [{ name: 'About Us', path: '/about-us' }],
    '/business-location': [{ name: 'Business Location', path: '/business-location' }],
    '/privacy-policy': [{ name: 'Privacy Policy', path: '/privacy-policy' }],
    '/refund-and-return-policy': [{ name: 'Refund and Return Policy', path: '/refund-and-return-policy' }],
    '/cyber-security': [{ name: 'Cyber Security', path: '/cyber-security' }],
    '/shipping-and-cancellation-policy': [{ name: 'Shipping and Cancellation Policy', path: '/shipping-and-cancellation-policy' }],
    '/terms-and-conditions': [{ name: 'Terms and Conditions', path: '/terms-and-conditions' }],
    '/mobile/terms-and-conditions': [{ name: 'Mobile Terms and Conditions', path: '/mobile/terms-and-conditions' }],
    '/mobile/privacy-policy': [{ name: 'Mobile Privacy Policy', path: '/mobile/privacy-policy' }],
    '/ilassist/privacy-policy': [{ name: 'iLASSIST Privacy Policy', path: '/ilassist/privacy-policy' }],
    '/platform': [{ name: 'Platform', path: '/platform' }],
    '/resources': [{ name: 'Resources', path: '/resources' }],
    '/solutions': [{ name: 'Solutions', path: '/solutions' }],
    '/solutions/business': [{ name: 'Business', path: '/solutions/business' }],
    '/solutions/business/automotive-oem': [
      { name: 'Business', path: '/solutions/business' },
      { name: 'Automotive OEM Solutions', path: '/solutions/business/automotive-oem' }
    ],
    '/solutions/business/fleet-logistics': [
      { name: 'Business', path: '/solutions/business' },
      { name: 'Fleet Logistics', path: '/solutions/business/fleet-logistics' }
    ],
    '/solutions/business/insurance': [
      { name: 'Business', path: '/solutions/business' },
      { name: 'Insurance', path: '/solutions/business/insurance' }
    ],
    '/solutions/business/enterprise': [
      { name: 'Business', path: '/solutions/business' },
      { name: 'Enterprise', path: '/solutions/business/enterprise' }
    ],
    '/solutions/consumers': [{ name: 'Consumers', path: '/solutions/consumers' }],
    '/solutions/consumers/connected-car': [
      { name: 'Consumers', path: '/solutions/consumers' },
      { name: 'Connected Car', path: '/solutions/consumers/connected-car' }
    ],
    '/solutions/consumers/safety-alerts': [
      { name: 'Consumers', path: '/solutions/consumers' },
      { name: 'Safety Alerts', path: '/solutions/consumers/safety-alerts' }
    ],
    '/solutions/consumers/rewards': [
      { name: 'Consumers', path: '/solutions/consumers' },
      { name: 'Rewards', path: '/solutions/consumers/rewards' }
    ],
    '/solutions/consumers/device-store': [
      { name: 'Consumers', path: '/solutions/consumers' },
      { name: 'Device Store', path: '/solutions/consumers/device-store' }
    ],
    '/products': [{ name: 'Products', path: '/products' }],
    '/products/hardware': [
      { name: 'Products', path: '/products' },
      { name: 'Hardware', path: '/products/hardware' }
    ],
    '/products/connectiq': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' }
    ],
    '/products/connectiq/babelfish': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'Babelfish', path: '/products/connectiq/babelfish' }
    ],
    '/products/connectiq/w4iq': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'W4IQ', path: '/products/connectiq/w4iq' }
    ],
    '/products/connectiq/vc-score': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'VC Score', path: '/products/connectiq/vc-score' }
    ],
    '/products/connectiq/miles': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'Miles', path: '/products/connectiq/miles' }
    ],
    '/products/connectiq/vstore': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'VStore', path: '/products/connectiq/vstore' }
    ],
    '/products/connectiq/cap': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'CAP', path: '/products/connectiq/cap' }
    ],
    '/products/connectiq/oasis': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'Oasis', path: '/products/connectiq/oasis' }
    ],
    '/products/connectiq/iiot': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'IIoT', path: '/products/connectiq/iiot' }
    ],
    '/products/connectiq/vehicle-app-store': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'Vehicle App Store', path: '/products/connectiq/vehicle-app-store' }
    ],
    '/products/connectiq/secureiq': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'SecureIQ', path: '/products/connectiq/secureiq' }
    ],
    '/products/connectiq/context-based-messaging': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'iQ360', path: '/products/connectiq/iq360' }
    ],
    '/products/connectiq/iq360': [
      { name: 'Products', path: '/products' },
      { name: 'ConnectIQ', path: '/products/connectiq' },
      { name: 'iQ360', path: '/products/connectiq/iq360' }
    ],
    '/products/unifiedsdk': [
      { name: 'Products', path: '/products' },
      { name: 'United SDK', path: '/products/unifiedsdk' }
    ],
    '/products/hardware/obd': [
      { name: 'Products', path: '/products' },
      { name: 'Hardware', path: '/products/hardware' },
      { name: 'OBD', path: '/products/hardware/obd' }
    ],
    '/products/hardware/tcu': [
      { name: 'Products', path: '/products' },
      { name: 'Hardware', path: '/products/hardware' },
      { name: 'TCU', path: '/products/hardware/tcu' }
    ],
    '/products/hardware/dashcam': [
      { name: 'Products', path: '/products' },
      { name: 'Hardware', path: '/products/hardware' },
      { name: 'Dashcam', path: '/products/hardware/dashcam' }
    ],
    '/products/hardware/cluster': [
      { name: 'Products', path: '/products' },
      { name: 'Hardware', path: '/products/hardware' },
      { name: 'Digital Cluster', path: '/products/hardware/cluster' }
    ],
    '/store/product': [{ name: 'Store', path: '/store/product' }],
    '/store/product/vc-drive-smart-platinum': [
      { name: 'Store', path: '/store/product' },
      { name: 'VC Drivesmart Platinum', path: '/store/product/vc-drive-smart-platinum' }
    ],
    '/store/product/camzo': [
      { name: 'Store', path: '/store/product' },
      { name: 'Camzo by Varroc Connect', path: '/store/product/camzo' }
    ],
    '/store/product/CarIQ-Driven-Gold': [
      { name: 'Store', path: '/store/product' },
      { name: 'CarIQ Driven Gold', path: '/store/product/CarIQ-Driven-Gold' }
    ],
    '/blog': [{ name: 'Blog', path: '/blog' }],
    '/careers': [{ name: 'Careers', path: '/careers' }],
    '/admin/greetings': [{ name: 'Admin', path: '/admin/greetings' }]
  };

  constructor(
    private router: Router,
    private analytics: AnalyticsService,
    private title: Title,
    private meta: Meta,
     private metaService: MetaService ,
    private seoService: SeoService,
    @Inject(DOCUMENT) private document: Document,
    private schemaService: SchemaService
  ) { }

  ngOnInit(): void {

    this.schemaService.addOrganizationSchema();
    this.routerEventsSub = this.router.events.pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((event: any) => {
        const pageName = this.getPageName(event.urlAfterRedirects);
        const pageTitle = this.title.getTitle();
        const userId = localStorage.getItem('user_id') || 'guest';
        
        // Update canonical and hreflang tags
        this.updateCanonicalUrl(event.urlAfterRedirects);
        this.updateHreflangTags(event.urlAfterRedirects);
      this.updateBreadcrumbSchema(event.urlAfterRedirects);

        // Refresh AOS after each routed page render.
        this.scheduleAosRefresh();
      });
  }

  ngAfterViewInit(): void {
    this.initializeAos();
    this.scheduleAosRefresh();
  }

  ngOnDestroy(): void {
    this.routerEventsSub?.unsubscribe();
  }

  private initializeAos(): void {
    try {
      if (typeof AOS === 'undefined') {
        return;
      }

      if (!this.aosInitialized) {
        AOS.init({ duration: 700, easing: 'ease-out-cubic', once: true, offset: 80 });
        this.aosInitialized = true;
      }

      this.refreshAos();
    } catch (e) {}
  }

  private scheduleAosRefresh(): void {
    if (typeof window === 'undefined') {
      return;
    }

    window.requestAnimationFrame(() => {
      setTimeout(() => this.refreshAos(), 0);
    });
  }

  private refreshAos(): void {
    try {
      if (typeof AOS === 'undefined') {
        return;
      }

      if (typeof AOS.refreshHard === 'function') {
        AOS.refreshHard();
      } else if (typeof AOS.refresh === 'function') {
        AOS.refresh();
      }
    } catch (e) {}
  }

  /** Helper to clean page name from URL */
  private getPageName(url: string): string {
    if (!url || url === '/' || url === '/home') return 'home';
    return url.replace(/^\/+/, '').replace(/\/+/g, '_').replace(/[^a-zA-Z0-9_]/g, '') || 'unknown';
  }
  private updateBreadcrumbSchema(url: string): void {
    const breadcrumbItems = this.buildBreadcrumbItems(url);
    if (!breadcrumbItems.length) {
      return;
    }

    const baseUrl = 'https://varrocconnect.com';
    this.seoService.addBreadcrumbJsonLd(
      breadcrumbItems.map(item => ({
        name: item.name,
        item: baseUrl + item.path
      }))
    );
  }

  private buildBreadcrumbItems(url: string): Array<{ name: string; path: string }> {
    const cleanedUrl = this.cleanUrl(url);
    if (!cleanedUrl || cleanedUrl === '/' || cleanedUrl === '/home') {
      return [];
    }

    if (this.breadcrumbRouteMap[cleanedUrl]) {
      return this.breadcrumbRouteMap[cleanedUrl];
    }

    if (cleanedUrl.startsWith('/blog/')) {
      return [
        { name: 'Blog', path: '/blog' },
        { name: 'Blog Post', path: cleanedUrl }
      ];
    }

    if (cleanedUrl.startsWith('/careers/') && cleanedUrl !== '/careers') {
      return [
        { name: 'Careers', path: '/careers' },
        { name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }
      ];
    }

    if (cleanedUrl.startsWith('/store/product/') && cleanedUrl !== '/store/product') {
      return [
        { name: 'Store', path: '/store/product' },
        { name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }
      ];
    }

    if (cleanedUrl.startsWith('/products/connectiq/') && cleanedUrl !== '/products/connectiq') {
      return [
        { name: 'Products', path: '/products' },
        { name: 'ConnectIQ', path: '/products/connectiq' },
        { name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }
      ];
    }

    if (cleanedUrl.startsWith('/products/hardware/') && cleanedUrl !== '/products/hardware') {
      return [
        { name: 'Products', path: '/products' },
        { name: 'Hardware', path: '/products/hardware' },
        { name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }
      ];
    }

    if (cleanedUrl.startsWith('/products/unifiedsdk/') && cleanedUrl !== '/products/unifiedsdk') {
      return [
        { name: 'Products', path: '/products' },
        { name: 'United SDK', path: '/products/unifiedsdk' },
        { name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }
      ];
    }

    if (cleanedUrl.startsWith('/solutions/business/') && cleanedUrl !== '/solutions/business') {
      return [
        { name: 'Business', path: '/solutions/business' },
        { name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }
      ];
    }

    if (cleanedUrl.startsWith('/solutions/consumers/') && cleanedUrl !== '/solutions/consumers') {
      return [
        { name: 'Consumers', path: '/solutions/consumers' },
        { name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }
      ];
    }

    return [{ name: this.humanizePathSegment(cleanedUrl.split('/').pop() || ''), path: cleanedUrl }];
  }

  private cleanUrl(url: string): string {
    return url.split(/[?#]/)[0].replace(/\/+$/, '');
  }

  private humanizePathSegment(segment: string): string {
    const mapping: { [key: string]: string } = {
      'blog-post': 'Blog Post',
      'devops-engineer-requirment': 'DevOps Engineer Requirement',
      'android-developer-requirement': 'Android Developer Requirement',
      'java-developer-requirement': 'Java Developer Requirement',
      'ios-developer-requirement': 'iOS Developer Requirement',
      'product-marketing-associate': 'Product Marketing Associate',
      'inside-sales-and-customer-support-specialist': 'Inside Sales and Customer Support Specialist',
      'junior-QA-engineer': 'Junior QA Engineer',
      'senior-software-engineer-ios': 'Senior Software Engineer iOS',
      'mobile-app-lead-manager': 'Mobile App Lead Manager',
      'project-manager-requirement': 'Project Manager Requirement',
      'product-manager': 'Product Manager',
      'vc-drive-smart-platinum': 'VC Drivesmart Platinum',
      'camzo-by-varroc-connect': 'Camzo by Varroc Connect',
      'CarIQ-Driven-Gold': 'CarIQ Driven Gold',
      'w4iq': 'W4IQ',
      'vstore': 'VStore',
      'cap': 'CAP',
      'iiot': 'IIoT',
      'secureiq': 'SecureIQ',
      'context-based-messaging': 'iQ360',
      'iq360': 'iQ360'
    };

    if (mapping[segment]) {
      return mapping[segment];
    }

    return segment
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }
  private getBaseUrl(): string {
    return `${window.location.protocol}//${window.location.host}`;
  }

  private updateCanonicalUrl(url: string): void {
    const baseUrl = this.getBaseUrl();
    const canonicalUrl = baseUrl + url;
    
    // Remove existing canonical link
    const existingCanonical = this.document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    // Add new canonical link
    const canonicalLink = this.document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', canonicalUrl);
    this.document.head.appendChild(canonicalLink);
  }

  private updateHreflangTags(url: string): void {
    const baseUrl = this.getBaseUrl();
    const currentUrl = baseUrl + url;
    
    // Remove existing hreflang links
    const existingHreflang = this.document.querySelectorAll('link[rel="alternate"]');
    existingHreflang.forEach(link => link.remove());
    
    // Add new hreflang link
    const hreflangLink = this.document.createElement('link');
    hreflangLink.setAttribute('rel', 'alternate');
    hreflangLink.setAttribute('hreflang', 'en-in');
    hreflangLink.setAttribute('href', currentUrl);
    this.document.head.appendChild(hreflangLink);
  }
}
